module.exports = __webpack_public_path__ + "img/1.a0894613.png";